function normalizeBebezikBundleCards(root) {
  root?.querySelectorAll?.('[data-bb-bundle-card]').forEach((card) => {
    const type = String(card.dataset.bundleType || '').toLowerCase();
    const copy = type === 'duo'
      ? { title: 'İkili Avantaj Seti', meta: '2× Biberon Destek Yastığı · 1× önlük hediye · 4× mendil hediye', role: 'İkili set' }
      : type === 'basic'
        ? { title: 'Standart Paket', meta: '1× Biberon Destek Yastığı · 2× mendil hediye', role: 'Ana ürün' }
        : null;
    if (!copy) return;
    const title = card.querySelector('.bb-bundle-card__title');
    const meta = card.querySelector('.bb-bundle-card__meta');
    const role = card.querySelector('[data-bundle-role="main"] .bb-bundle-card__role');
    if (title && title.textContent !== copy.title) title.textContent = copy.title;
    if (meta && meta.textContent !== copy.meta) meta.textContent = copy.meta;
    if (role && role.textContent !== copy.role) role.textContent = copy.role;
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.bindOverlay();
    this.bindCartIcon();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay || overlay.dataset.bbBound) return;
    overlay.dataset.bbBound = '1';
    overlay.addEventListener('click', this.close.bind(this));
  }

  bindCartIcon() {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link || link.dataset.bbDrawerBound) return;
    link.dataset.bbDrawerBound = '1';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(link);
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.activeElement = triggeredBy;
    requestAnimationFrame(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-items')?.dispatchViewEvent?.();
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  parse(html, selector) {
    if (typeof html !== 'string' || !html.trim()) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  renderContents(state) {
    const sections = state?.sections;
    const html = sections?.['cart-drawer'];
    const parsedRoot = this.parse(html, 'cart-drawer');
    const next = this.parse(html, '#CartDrawer');
    const current = this.querySelector('#CartDrawer');
    if (!parsedRoot || !next || !current) {
      console.error('[Bebezik] Geçerli cart-drawer section alınamadı; boş drawer açılmadı.');
      return false;
    }

    const empty = parsedRoot.classList.contains('is-empty');
    current.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));

    const icon = document.getElementById('cart-icon-bubble');
    const iconSection = this.parse(sections?.['cart-icon-bubble'], '.shopify-section');
    if (icon && iconSection) icon.innerHTML = iconSection.innerHTML;

    this.productId = state?.id ?? null;
    this.classList.toggle('is-empty', empty);
    this.querySelector('.drawer__inner')?.classList.toggle('is-empty', empty);
    this.querySelector('cart-drawer-items')?.classList.toggle('is-empty', empty);
    this.bindOverlay();
    normalizeBebezikBundleCards(this);
    requestAnimationFrame(() => this.open());
    return true;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return this.parse(html, selector)?.innerHTML ?? null;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  'use strict';
  if (window.__bbTwoOfferCartBridge) return;
  window.__bbTwoOfferCartBridge = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const PREVIEW_KEYS = ['preview_theme_id', 'pb', '_fd'];

  const withPreview = (path) => {
    const url = new URL(path, location.origin);
    const current = new URL(location.href);
    PREVIEW_KEYS.forEach((key) => {
      const value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    return `${url.pathname}${url.search}`;
  };

  const cartContext = () => withPreview(window.routes?.cart_url || '/cart');
  const endpoint = (route, fallback) => withPreview(`${(route || fallback).replace(/\.js$/, '')}.js`);

  const timedFetch = (url, options = {}, ms = 12000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ms);
    return fetch(url, { ...options, signal: controller.signal }).finally(() => clearTimeout(timer));
  };

  const validSections = (sections) =>
    Boolean(sections && typeof sections['cart-drawer'] === 'string' && sections['cart-drawer'].trim());

  const renderDrawer = (sections, id = null) => {
    if (!validSections(sections)) return false;
    const drawer = document.querySelector('cart-drawer');
    return Boolean(drawer?.renderContents?.({ id, sections }));
  };

  const refreshDrawer = async () => {
    const url = new URL(cartContext(), location.origin);
    url.searchParams.set('sections', SECTIONS.join(','));
    try {
      const response = await timedFetch(`${url.pathname}${url.search}`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }, 8000);
      if (!response.ok) return false;
      return renderDrawer(await response.json().catch(() => null));
    } catch (error) {
      console.error('[Bebezik] Drawer yenileme hatası:', error);
      return false;
    }
  };

  const cartHasBundle = async (bundleId) => {
    try {
      const response = await timedFetch(endpoint(window.routes?.cart_url, '/cart'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }, 5000);
      if (!response.ok) return false;
      const cart = await response.json();
      return (cart.items || []).some((item) =>
        item.properties?._bundle_id === bundleId || item.properties?._bb_upsell_for === bundleId
      );
    } catch (_) {
      return false;
    }
  };

  const patchHero = () => {
    const Hero = window.BebezikBundleHero;
    const Model = window.BebezikBundleModel;
    if (!Hero?.prototype || !Model || Hero.prototype.__bbCartPatched) return false;
    Hero.prototype.__bbCartPatched = true;
    Hero.prototype.refreshDrawer = refreshDrawer;
    Hero.prototype.cartHasBundle = cartHasBundle;

    Hero.prototype.addSelection = async function () {
      const status = this.status();
      if (!status?.ready || this.state.busy) {
        this.state.error = status?.message || '';
        this.render();
        return;
      }

      const first = this.mainVariant(this.state.firstMainId);
      const second = this.mainVariant(this.state.secondMainId);
      const includedBib = this.bibVariant(this.state.includedBibId);
      const upsellBib = this.state.upsellEnabled ? this.bibVariant(this.state.upsellBibId) : null;
      const cloth = this.config.products.cloth?.variants?.find(Model.isAvailable) || null;
      const bundleId = `bb-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
      const items = Model.buildCartItems({
        packageType: this.state.packageType,
        bundleId,
        mainVariant: first,
        clothVariant: cloth,
        duoVariant: this.selectedDuoVariant(),
        firstColor: first?.color || first?.title,
        secondColor: second?.color || second?.title,
        includedBib: includedBib?.title,
        upsellBibVariant: upsellBib
      });

      if (!items?.length) {
        this.state.error = 'Sepete eklenecek paket oluşturulamadı.';
        this.render();
        return;
      }

      this.state.busy = true;
      this.state.error = '';
      this.render();
      let confirmed = false;

      try {
        const response = await timedFetch(endpoint(window.routes?.cart_add_url, '/cart/add'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: SECTIONS, sections_url: cartContext() })
        });
        const state = await response.json().catch(() => ({}));
        if (!response.ok || state.status) {
          throw new Error(state.description || state.message || 'Ürünler sepete eklenemedi.');
        }
        confirmed = true;
        if (renderDrawer(state.sections, state.id ?? null)) return;
        if (await refreshDrawer()) return;
        this.state.error = 'Ürün sepete eklendi ancak açılır sepet yenilenemedi. Sepet ikonundan kontrol edebilirsiniz.';
      } catch (error) {
        if (!confirmed) confirmed = await cartHasBundle(bundleId);
        if (confirmed) {
          if (await refreshDrawer()) return;
          this.state.error = 'Ürün sepete eklendi ancak açılır sepet yenilenemedi. Sepet ikonundan kontrol edebilirsiniz.';
        } else {
          this.state.error = error?.name === 'AbortError'
            ? 'Sepet isteği zaman aşımına uğradı ve ürünün eklendiği doğrulanamadı. Lütfen tekrar deneyin.'
            : (error?.message || 'Ürünler sepete eklenemedi.');
        }
      } finally {
        this.state.busy = false;
        this.render();
      }
    };
    return true;
  };

  if (!patchHero()) {
    document.addEventListener('DOMContentLoaded', patchHero, { once: true });
    setTimeout(patchHero, 0);
  }
})();
